import ArrowBack from './ArrowBack.png';
import AutoRecommendationIcon from './AutoRecommendationIcon.png'
import CourseRankingsIcon from './CourseRankingsIcon.png';
import GraphicsIcon from './GraphicsIcon.png';
import PcIcon from './PcIcon.png';
import PhoneIcon from './PhoneIcon.png';
import PopularSpeechIcon from './PopularSpeechIcon.png';
import RecommendationIcon from './RecommendationIcon.png';
import ArrowBackDisabled from './ArrowBackDisabled.png';
import DeleteIcon from './DeleteIcon.png';
import AddIcon from './AddIcon.png';
import HasMoreIcon from './HasMoreIcon.png';
import HasMoreActiveIcon from './HasMoreActiveIcon.png';
import EditIcon from './EditIcon.png';
import ViewCourseIcon from './ViewCourseIcon.png';
import EditImgIcon from './EditImgIcon.png';
import AddWhiteIcon from './AddWhiteIcon.png';
import CheckIcon from './CheckIcon.png';
import RadioActiveIcon from './RadioActiveIcon.png';
import RadioNormalIcon from './RadioNormalIcon.png';
import TipIcon from './TipIcon.png';
import CheckboxNormalIcon from './checkboxNormalIcon.png';
import CheckBoxIcon from './CheckBoxIcon.png';
import CheckUnknownIcon from './CheckUnknownIcon.png';
import ArrowDownIcon from './icon-arrow-down.png';
import ArrowRightIcon from './ArrowRightIcon.png';
import RefreshIcon from './RefreshIcon.png';
import DefaultAvatarIcon from './DefaultAvatarIcon.png';
import IconCnt from './IconCnt.png';
import CursorDraggingIcon from './CursorDraggingIcon.png';
import ImageClassIcon from './icon-class.png';
import ImageGroupIcon from './icon-group.png';
import ImageDepartmentYellowIcon from './icon-department-yellow.png';
import ArchitectureIcon from './icon-architecture.png';
import NavCloseIcon from './NavClose.png';
import OfficiallIcon from './officialIcon.png';
import ProductIcon from './productIcon.png';
import PictureCover from './pictureCover.png';
import RichTextIcon from './richTextIcon.png';
import VideoIcon from './videoIcon.png';
import DocumentIcon from './documentIcon.png';
import LineSplitContent from './lineSplitContent.png';
export const IconImg = {
    PcIcon,
    NavCloseIcon,
    LineSplitContent,
    VideoIcon,
    DocumentIcon,
    ArchitectureIcon,
    RichTextIcon,
    OfficiallIcon,
    ProductIcon,
    ImageClassIcon,
    ImageGroupIcon,
    ImageDepartmentYellowIcon,
    AddIcon,
    IconCnt,
    CheckBoxIcon,
    RefreshIcon,
    CursorDraggingIcon,
    DefaultAvatarIcon,
    TipIcon,
    EditIcon,
    ArrowBack,
    ArrowRightIcon,
    ArrowDownIcon,
    CheckUnknownIcon,
    CheckIcon,
    PhoneIcon,
    DeleteIcon,
    EditImgIcon,
    AddWhiteIcon,
    GraphicsIcon,
    HasMoreIcon,
    CheckboxNormalIcon,
    ViewCourseIcon,
    RadioActiveIcon,
    RadioNormalIcon,
    HasMoreActiveIcon,
    ArrowBackDisabled,
    PopularSpeechIcon,
    RecommendationIcon,
    CourseRankingsIcon,
    PictureCover,
    AutoRecommendationIcon,
}
